import {
  Alert,
  Autocomplete,
  Box,
  Chip,
  Link,
  TextField,
  Typography
} from "@mui/material";
import { isEmpty, map, orderBy } from "lodash";
import MaterialReactTable from "material-react-table";
import { FC, UIEvent, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { BOOL_OPTIONS, FEATURES, ISSUE_STATE_OPTIONS, ROUTES, STATUS_OPTIONS, TOOL_TYPES } from "../../../constants";
import { useHasFeature } from "../../../hooks/feature/useHasFeature";
import useFetch from "../../../hooks/http/useFetch";
import { usePageContext } from "../../../hooks/process/usePageContext";
import { useTableInfinity } from "../../../hooks/process/useTableInfinity";
import { IBreadcrumbState, useBreadcrumbState } from "../../../store/breadcrumbState";
import { IUserStoreState, useUserStore } from "../../../store/userState";
import AIAssessmentChip from "../../common/aiSuggestions/aiAssessmentChip";
import SegregateChip from "../../common/aiSuggestions/segregate";
import CommonPopper from "../../common/commonPopper";
import FaultGroups from "../../common/faultGroups";
import TruncatedScrollingText from "../../common/truncatedScrollingText";
import {
  default as ActionButton,

  RISK_STATE_OPTIONS
} from "../ViewFindings/shared/button";
import { AIAvatar } from "../../common/finetunetag";

export const ColumnHeaderFilter: FC<any> = ({
  columnKey,
  name,
  options,
  setColumnHeaderFilter,
  columnHeaderFilter
}) => {
  return (
    <Typography variant="overline">
      {!isEmpty(options) ? (
        <Autocomplete
        getOptionLabel={(option: any) => option?.label}
        options={options}
        size="small"
        sx={{ fontSize: "12px", minWidth: "10em" }}
        multiple
        disableClearable
        value={
          options.filter((opt: any) => (columnHeaderFilter?.[columnKey] || []).includes(opt.key))
        }
        onChange={(e, value) => {
          setColumnHeaderFilter(columnKey, value.map((v: any) => v.key));
        }}
        renderOption={(props, option) => (
          <li {...props} key={option.key}>
            {option.label}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={name.toUpperCase()}
            name="severity"
            variant="standard"
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              sx: {
                fontSize: '0.75rem',
                fontWeight: 600,
                letterSpacing: '0.08em',
                color: 'text.primary',
                padding: 0,
              }
            }}
            sx={{
              fontSize: '0.75rem',
              fontWeight: 600,
              color: 'text.primary',
              lineHeight: 1.5,
            }}
          />
        )}
     
        // renderInput={(params): JSX.Element => (
        //   <TextField
        //     {...params}
        //     placeholder={name.toUpperCase()}
        //     variant="standard"
        //     InputProps={{
        //       ...params.InputProps,
        //       disableUnderline: true,
        //       sx: {
        //         fontSize: '0.75rem',
        //         fontWeight: 600,
        //         textTransform: 'uppercase',
        //         letterSpacing: '0.08em',
        //         color: 'text.primary',
        //         padding: 0,
        //       }
        //     }}
        //     sx={{
        //       padding: 0,
        //       backgroundColor: 'transparent',
        //       '& input': {
        //         padding: 0,
        //         fontSize: '0.75rem',
        //         fontWeight: 600,
        //         textTransform: 'uppercase',
        //         color: 'text.primary',
        //         lineHeight: 1.5,
        //         textTransform: "uppercase",
        //       }
        //     }}
        // />
        // )}
        />
      ) : null}
    </Typography>
  );
};

const LIMIT = 20;
const IssuesTable: FC<any> = ({
  history,
  location,
  limit = LIMIT,
  currentUserOnly = false,
  disableInfiniteScroll = false,
  disableFilters = false,
  maxHeight = "calc(100vh - 10em)"
}) => {
  const tableContainerRef = useRef<HTMLDivElement>(null);
  const { currentUser } = useUserStore((state) => state) as IUserStoreState;
  const hasAIPermissions = useHasFeature(FEATURES.AI_TRIAGE)


  const useQuery = () => new URLSearchParams(location.search);
  const query = useQuery();
  const categoryName = query.get("categoryName");

  const [columnHeaderFilter, setColumnHeaderFilter] = useState<any>({});
  const navigate = useHistory();


  const selectedGroup = useBreadcrumbState((state) =>
    //@ts-ignore
    state.selectedGroup)
  const selectedProject = useBreadcrumbState((state) =>
    //@ts-ignore
    state.selectedProject)
  const issuesUrl = useMemo(() => {



    let url = `/issues?limit={limit}&offset={offset}`;
    if (selectedGroup?.id) {
      url += `&groupId=${selectedGroup?.id}`;
    }
    if (currentUserOnly) {
      url += `&assigneeIds=${currentUser.uuid}`
    }
    if (selectedProject?.id) {
      url += `&projectId=${selectedProject?.id}`;
    }
    if (!disableFilters) {
      if (categoryName) {
        url += `&categoryName=${encodeURIComponent(categoryName)}`;
      }
    }

    if (!isEmpty(columnHeaderFilter)) {
      for (let key in columnHeaderFilter) {
        const columnFilterValues = columnHeaderFilter[key];
        for (let value of columnFilterValues) {
          if (value !== null) {
            url += `&${key}=${value}`;
          }
        }
      }
    }




    return url;
  }
    , [selectedProject, selectedGroup, currentUserOnly, disableFilters, columnHeaderFilter, currentUser.uuid, categoryName])


  const { data: faultGroupsData } = useFetch("/faultgroups");

  const { rows, fetchMoreOnBottomReached, isFetching } = useTableInfinity("issues",
    issuesUrl
    ,
    tableContainerRef,
    limit
  );

  const handleColumnHeaderFilterChange = useCallback((key: string, value: any[] | null) => {
    if (!isEmpty(value)) {
      setColumnHeaderFilter({ ...columnHeaderFilter, [key]: value! });
    } else {
      let newFilter = { ...columnHeaderFilter };
      delete newFilter[key];
      setColumnHeaderFilter({ ...newFilter });
    }
  }, [columnHeaderFilter]);

  const columns = useMemo(() => [
    {
      accessorKey: "findingType",
      header: "Type",
      Header: (
        <ColumnHeaderFilter
          columnKey="findingType"
          name="Type"
          options={TOOL_TYPES}
          setColumnHeaderFilter={handleColumnHeaderFilterChange}
        />
      ),
      Cell: (params: any) => (
        <Chip
          label={params?.row?.original?.findingType}
          size="small"
        />
      ),

      size: 100,

    },
    {
      accessorKey: "id",
      header: "ID",
      Cell: (params: any) => (
        <Link
          onClick={() => {
            history.push(
              `/findings?issueId=${params.row?.original?.id}`
            );
          }}
        >
          <Typography variant="h6" color={"primary"}>#{params.row?.original?.index}</Typography>
        </Link>
      ),
      size: 30,
    },
    {
      accessorKey: "risk",
      header: "Risk",
      Cell: (params: any) => (
        <ActionButton
          issueId={params?.row?.original?.id}
          buttons="RISK"
          risk={params?.row?.original?.risk}
          state={params?.row?.original?.state}
          user={params?.row?.original?.assignee}
          jira={{
            url: params?.row?.original?.jiraUrl,
            number: params?.row?.original?.jiraNumber,
          }}
        />
      ),
      Header: (
        <ColumnHeaderFilter
          columnKey="risk"
          name="Risk"
          options={RISK_STATE_OPTIONS}
          setColumnHeaderFilter={handleColumnHeaderFilterChange}
        />
      ),
      size: 30,
    },
    hasAIPermissions && {
      accessorKey: "aiRecommendation",

      header: <Typography variant="overline" sx={{ fontWeight: 600, textTransform: "uppercase" }}>🔵 Urgency</Typography>,
      size: 30,
      Cell: (params: any) => (
        <Box>
          {params?.row?.original?.aiRecommendation?.segregate && (
            <CommonPopper
              elevatePopper
              trigger={
                <Box>
                  <SegregateChip type={params?.row?.original?.aiRecommendation?.segregate} />
                </Box>
              }
              child={
                <Box>
                  <AIAssessmentChip
                    urgency={params?.row?.original?.aiRecommendation?.segregate}
                    technical={params?.row?.original?.aiRecommendation?.isImportantLLMJudgement ? "Important" : "Not Important"}
                    contextual={params?.row?.original?.aiRecommendation?.isImportantContextual ? "Important" : "Not Important"}
                    score={params?.row?.original?.aiRecommendation?.score}
                  />
                </Box>
              }
            />
          )}
        </Box>
      )
    },


    {
      accessorKey: "projectName",
      header: "Project",
      size: 100,
      Cell: (params: any) => {
        const path = ROUTES.PROJECT.replace(':projectId', params?.row?.original?.projectId);
        return (
          <Link className="hand" onClick={() => navigate.push(path)}>
            <TruncatedScrollingText
              name={params?.row?.original?.projectName}
              color={"text.primary"}
              typographyVariant='h6' />
          </Link>
        )
      }
    },


    {
      accessorKey: "assetName",
      header: "Asset",
      size: 100,
      Cell: (params: any) => {
        const path = ROUTES.PROJECT.replace(':projectId', params?.row?.original?.projectId) + `?assetid=${params?.row?.original?.assetId}`;
        return (
          <Box>

            <Link className="hand" onClick={() => navigate.push(path)}>
              <TruncatedScrollingText
                name={params?.row?.original?.assetName}
                color={"text.primary"}
                typographyVariant='h6' />
            </Link>
            <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "12px" }}>
              {params?.row?.original?.operationId}
            </Typography>
          </Box>
        )
      }


    },
    { accessorKey: "faultId", header: "Fault Id", size: 60 },

    { accessorKey: "findingName", header: "Name" },
    {
      accessorKey: "duration",
      header: "Open for",
      size: 40
    },

    {
      accessorKey: "faultGroup",
      header: "Fault Group",
      size: 50,
      Header: (
        <ColumnHeaderFilter
          columnKey="faultGroupId"
          name="Fault Group"
          options={faultGroupsData?.faultGroups.map(
            (group: any) => ({
              key: group.id,
              label: group.name,
            })
          )}
          setColumnHeaderFilter={handleColumnHeaderFilterChange}
        />
      ),
      Cell: (params: any) => (
        <FaultGroups faultGroupArray={params?.row?.original?.faultGroup?.split(',')} />
      )
    },
    {
      accessorKey: "environmentName",
      header: "Environment",
      size: 50,

    },


    {
      accessorKey: "status",

      header: "State",
      size: 30,
      Header: (
        <ColumnHeaderFilter
          columnKey="status"
          name="State"
          options={STATUS_OPTIONS}
          setColumnHeaderFilter={handleColumnHeaderFilterChange}
        />
      ),
    },

    {
      accessorKey: "state",

      header: "Status",
      size: 60,
      Header: (
        <ColumnHeaderFilter
          columnKey="state"
          name="Status"
          options={ISSUE_STATE_OPTIONS}
          setColumnHeaderFilter={handleColumnHeaderFilterChange}
        />
      ),
      Cell: (params: any) => (
        <ActionButton
          issueId={params?.row?.original?.id}
          buttons="STATE"
          risk={params?.row?.original?.risk}
          state={params?.row?.original?.state}
          user={params?.row?.original?.assignee}
          jira={{
            url: params?.row?.original?.jiraUrl,
            number: params?.row?.original?.jiraNumber,
          }}
        />
      ),


    },
    hasAIPermissions && {
      accessorKey: "isCodeFixAvailable",

      header: "Code Fix Available",
      size: 30,
      Cell: (params: any) => (
        <Box>


          <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "12px" }}>
            {"isCodeFixAvailable" in params?.row?.original ? params?.row?.original?.isCodeFixAvailable ? "Yes" : "No" : ""}
          </Typography>
        </Box>
      )
    },
    hasAIPermissions && {
      accessorKey: "isImportant",

      header: "Important",
      size: 30,
      Header: (
        <ColumnHeaderFilter
          columnKey="isImportant"
          name="Is Important"
          options={BOOL_OPTIONS}
          setColumnHeaderFilter={handleColumnHeaderFilterChange}
        />
      ),
      Cell: (params: any) => (
        <Box>


          <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "12px" }}>
            {"isImportant" in params?.row?.original ? params?.row?.original?.isImportant ? "Yes" : "No" : ""}
          </Typography>
        </Box>
      )
    },


    // {
    //   accessorKey: "updatedAt",
    //   header: "Last Seen",
    //   size: 30,
    //   Cell: (params: any) => (
    //     <> {moment(params?.row?.original?.updatedAt).format("H:mm DD MMM YYYY ")} </>
    //   ),
    // },
  ].filter((item): item is any => Boolean(item)), [faultGroupsData?.faultGroups, handleColumnHeaderFilterChange, hasAIPermissions, history])





  useEffect(() => {

    if (!disableInfiniteScroll) {
      fetchMoreOnBottomReached(tableContainerRef.current);
    }

  }, [columnHeaderFilter, disableInfiniteScroll, fetchMoreOnBottomReached, selectedProject, selectedGroup])




  return (
    <Box sx={{ mt: 2 }} key={`issues-${selectedGroup?.id}-${selectedProject?.id}`}>

      <MaterialReactTable muiTablePaperProps={{
        elevation: 0
      }} enableGlobalFilter={false}
        columns={columns}
        data={rows}


        initialState={{
          density: "compact",
          columnPinning: { left: ['id'] },
        }}
        enableColumnActions={false}
        enableSorting={false}
        enableStickyHeader
        enableBottomToolbar={false}
        enablePagination={false}
        enableDensityToggle={false}
        enableColumnFilters={false}
        enableTopToolbar={false}
        // enableRowVirtualization
        state={{

          showProgressBars: isFetching,
        }}

        muiTableContainerProps={{
          ref: tableContainerRef, //get access to the table container element
          sx: { maxHeight: maxHeight }, //give the table a max height
          onScroll: (
            event: UIEvent<HTMLDivElement> //add an event listener to the table container element
          ) => {


            if (!disableInfiniteScroll) {
              fetchMoreOnBottomReached(event.target as HTMLDivElement)
            }

          }

        }}
      />
    </Box>
  );
};


export const GroupProjectBreadcrumb: FC<any> = ({ disableEdit = false, filtersToHide = [] }) => {
  const { changeGroup, changeProject, handleGroupSearchChange, handleProjectSearchChange } = usePageContext();
  const { setOverrideBreadcrumb, groups, projects, selectedGroup, selectedProject } = useBreadcrumbState() as IBreadcrumbState


  useEffect(() => {
    handleGroupSearchChange(null)
  }, [])
  // useEffect(() => {
  //   setOverrideBreadcrumb(null)
  // }, [setOverrideBreadcrumb])

  /**
   * If the edit is disabled, we will not show the dropdowns
   */
  if (disableEdit && false) {
    // return <Box sx={{ display: "flex", justifyContent: "start", width: "fit-content", mt: 2 }}>
    //   {!groupsLoading && filtersToHide?.indexOf("group") < 0 && !isEmpty(groups) && <Chip
    //     size="small"
    //     label={<Box sx={{ display: "flex", alignItems: "center" }}>
    //       <Typography variant="caption" sx={{ fontWeight: 700 }}>
    //         Group:
    //       </Typography>
    //       <Typography variant="caption" sx={{ ml: 1 }}>
    //         {selectedGroup?.name}
    //       </Typography>
    //     </Box>}
    //   />
    //   }
    //   {!projectsLoading && filtersToHide?.indexOf("project") < 0 && !isEmpty(projects) && <Chip
    //     size="small"
    //     sx={{ ml: 1 }}
    //     label={<Box sx={{ display: "flex", alignItems: "center", }}>
    //       <Typography variant="caption" sx={{ fontWeight: 700 }}>
    //         Project:
    //       </Typography>
    //       <Typography variant="caption" sx={{ ml: 1 }}>
    //         {selectedProject?.name}
    //       </Typography>
    //     </Box>}
    //   />
    //   }
    // </Box>
  }

  /**
   * If the edit is enabled, we will show the dropdowns
   * and allow the user to change the group and project
   */
  return <Box sx={{ display: "flex", justifyContent: "start", width: "fit-content", mt: 2 }}>
    {(filtersToHide?.indexOf("group") < 0) ? <Autocomplete
      key={`group-${selectedGroup?.id || 'default'}`}
      className="hand"
      options={orderBy(groups || [], "name")}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={selectedGroup}
      size="small"
      disabled={disableEdit}
      //@ts-ignore
      // onBlur={changeGroup}
      disableClearable

      onInputChange={(e: any) => {
        handleGroupSearchChange(e)
      }}
      onChange={async (event, newValue) => {
        await changeGroup(newValue?.id)

      }}
      sx={{
        minWidth: "10em",
        width: "fit-content",
        mb: 2,
        textAlign: "left",
      }}
      renderInput={(params) => (
        <TextField {...params} label="Group" sx={{ border: "1px solid #e5e5e5" }} InputLabelProps={{ disableAnimation: true }}
        />
      )}
      renderOption={(props, option) => (
        option?.id === "SEARCH_FOR_MORE" ? <li>
          <Alert icon={false} color="info">
            Search for more...
          </Alert>
        </li> : <li {...props}>
          <TruncatedScrollingText name={option?.name} maxLength={15} />
        </li>
      )}
    /> : null}
    {<Autocomplete
      key={`project-${selectedProject?.id || 'default'}`}
      options={orderBy(projects || [], "name")}
      className="hand"
      getOptionLabel={(option) => option.name}
      value={selectedProject}
      size="small"
      disabled={disableEdit}
      onInputChange={handleProjectSearchChange}
      onChange={(event, newValue) => {
        if (newValue) {
          changeProject(newValue?.id)
        } else {
          changeProject(undefined, true)
        }
      }}
      sx={{
        minWidth: "10em",
        width: "fit-content",
        pl: 1,
        mb: 2,

        textAlign: "left",
      }}
      renderInput={(params) => (
        <TextField {...params} label="Project" sx={{ border: "1px solid #e5e5e5" }} InputLabelProps={{ disableAnimation: true }} />
      )}
      renderOption={(props, option) => (
        option?.id === "SEARCH_FOR_MORE" ? <li >
          <Alert icon={false} color="info">
            Search for more...
          </Alert>
        </li> : <li {...props}>
          <TruncatedScrollingText name={option?.name} maxLength={15} />
        </li>
      )}
    />}
  </Box>
}

export default withRouter(IssuesTable);
